"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Fedora = function Fedora(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return _react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), _react.default.createElement("path", {
    d: "M12.004.002C7.29-.063 2.744 2.963.957 7.318c-.884 1.953-1 4.116-.945 6.225.01 2.666-.02 5.334.015 7.998.113 1.542 1.653 2.614 3.133 2.441 3.257-.02 6.514.043 9.77-.035 4.789-.303 9.154-3.796 10.525-8.39 1.401-4.344.03-9.412-3.389-12.442A11.967 11.967 0 0012.004.002zm3.52 2.842c.406-.01.807.032 1.197.117.557.286.945.826.902 1.383-.058.75-.587 1.247-1.379 1.246a2.95 2.95 0 00-.72-.09c-1.726-.053-3.168 1.61-2.97 3.305.023.796-.045 1.601.032 2.392.333.457.987.18 1.475.256.276-.001.562.007.85.008a.134.134 0 00.042.008 1.29 1.29 0 011.291 1.295 1.29 1.29 0 01-1.299 1.295.14.14 0 00-.06.013c-.777.003-1.553-.001-2.33.002-.066 1.616.197 3.275-.31 4.84-.864 2.705-3.97 4.336-6.684 3.62-.537-.285-.91-.791-.868-1.335.062-.796.656-1.308 1.532-1.24.075.006.113.012.168.02.716.14 1.477.034 2.107-.391 1.127-.645 1.502-1.977 1.396-3.192-.02-.687.043-1.384-.033-2.066-.333-.456-.984-.18-1.472-.256H7.59a.137.137 0 00-.065-.015 1.29 1.29 0 01-1.298-1.295c0-.72.574-1.29 1.29-1.295a.136.136 0 00.063-.016h2.316c.059-1.507-.159-3.046.213-4.523.648-2.376 2.951-4.12 5.414-4.086zm.705.052l.13.024-.13-.024zm1.224.28c1.444.543 2.636 1.706 3.25 3.12A81.134 81.134 0 0117.8 3.704a1.762 1.762 0 00-.346-.527zm.45.935a86.952 86.952 0 002.966 2.596c-.014-.044-.033-.087-.049-.13.166.448.265.918.301 1.402a77.84 77.84 0 01-3.39-2.975l.015-.033c.088-.182.143-.386.16-.606a1.393 1.393 0 000-.197c0-.019-.002-.038-.004-.057zm.02.196c-.058.516-.058.516 0 0zm-.314.894a85.339 85.339 0 003.53 3.06c0 .071.015.139.013.21a4.94 4.94 0 01-.06.814 78.521 78.521 0 01-4.082-3.584 1.56 1.56 0 00.6-.5zm.526 1.83c.898.8 1.856 1.623 2.918 2.485a5.215 5.215 0 01-.242.863 74.025 74.025 0 01-2.307-1.963l.002.055c0 .076-.004.152-.01.226.703.612 1.44 1.237 2.24 1.885-.109.26-.234.512-.38.752a73.598 73.598 0 01-2.06-1.752 3.13 3.13 0 00-.161-2.55zm.068 2.758c.644.56 1.319 1.131 2.043 1.72a5.867 5.867 0 01-.5.651 74.233 74.233 0 01-1.99-1.705c.185-.2.332-.425.447-.666zm-.603.816a82.538 82.538 0 002.005 1.71c-.19.199-.392.385-.607.556a75.851 75.851 0 01-2.043-1.771c.203-.107.396-.246.572-.424.027-.022.047-.047.073-.07zm-.86.594a84.363 84.363 0 002.088 1.799c-.23.17-.48.312-.734.445a79.052 79.052 0 01-2.256-2.005c-.024.002-.05.001-.074.003l-.026-.015a3.506 3.506 0 001.002-.227zm-10.045.248l-.021.014h-.012l.004.004c-.211.139-.387.328-.51.55l-.45-.427c.323-.075.655-.126.99-.14zm-.994.14l-.127.032.127-.031zm-.27.075l.622.592a1.55 1.55 0 00.008 1.045c-.468-.444-.94-.893-1.432-1.348.26-.118.529-.21.803-.289zm-1.029.4c.72.674 1.424 1.347 2.133 2.03a2.68 2.68 0 00-.826.242c-.64-.611-1.3-1.23-1.998-1.865.22-.152.453-.285.691-.406zm12.02.204c.473.42.958.846 1.474 1.285a5.37 5.37 0 01-.908.342l-.617-.498a1.55 1.55 0 00.05-1.13zm-12.9.345c.665.614 1.316 1.228 1.958 1.844-.83.485-1.422 1.376-1.527 2.332A98.32 98.32 0 001.777 14.8a5.573 5.573 0 00-.091.219c.777.699 1.522 1.392 2.252 2.087.002.284.042.57.14.848.053.19.13.366.22.533a107.233 107.233 0 00-2.859-2.634c.026-.108.04-.217.073-.323.137-.518.366-.998.65-1.441.69.622 1.35 1.242 2.002 1.861a2.98 2.98 0 01.107-.232 99.448 99.448 0 00-1.986-1.819c.15-.214.311-.42.49-.613.662.602 1.296 1.202 1.926 1.803.054-.06.11-.122.168-.178-.618-.585-1.26-1.18-1.94-1.79a5.82 5.82 0 01.592-.509zm12.718.153l-.027.265.027-.265zm1.733.754l-.051.023.05-.023zm-1.72.091l.44.354c-.287.06-.582.096-.88.103h-.016a1.56 1.56 0 00.457-.457zM1.386 16.102c1.32 1.188 2.532 2.356 3.781 3.558l.174.166c-.237.107-.44.266-.594.465A125.931 125.931 0 001.3 17.076a5.176 5.176 0 01.086-.975zm-.07 1.289a154.272 154.272 0 013.294 3.111c-.109.2-.18.427-.199.676a1.406 1.406 0 000 .166c-.92-.884-1.857-1.779-2.88-2.71a5.65 5.65 0 01-.216-1.243zm.378 1.714c.943.876 1.852 1.748 2.778 2.64l.021.02c.07.195.185.372.326.532-1.445-.56-2.562-1.767-3.125-3.192zm3.352.264c.179.14.374.26.58.358l-.025.005-.018-.015a3.014 3.014 0 01-.537-.348zm1.047 3.252l.15.025-.15-.025zm.228.04s.09.007.274.025a33.668 33.668 0 00-.274-.026Z"
  }));
};

Fedora.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Fedora.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Fedora;
exports.default = _default;